'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHeightWidthMax = exports.getHeightWidth = exports.getWindowWidthMax = exports.getWindowWidth = exports.getWindowHeightMax = exports.getWindowHeight = exports.getWindowSize = exports.REDUCER_KEY = undefined;

var _property2 = require('lodash/property');

var _property3 = _interopRequireDefault(_property2);

var _reselect = require('reselect');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var REDUCER_KEY = exports.REDUCER_KEY = 'windowSize';
var getWindowSize = exports.getWindowSize = (0, _property3.default)(REDUCER_KEY);
var getWindowHeight = exports.getWindowHeight = (0, _property3.default)([REDUCER_KEY, 'height']);
var getWindowHeightMax = exports.getWindowHeightMax = (0, _property3.default)([REDUCER_KEY, 'heightMax']);
var getWindowWidth = exports.getWindowWidth = (0, _property3.default)([REDUCER_KEY, 'width']);
var getWindowWidthMax = exports.getWindowWidthMax = (0, _property3.default)([REDUCER_KEY, 'widthMax']);
var getHeightWidth = exports.getHeightWidth = (0, _reselect.createStructuredSelector)({
  height: getWindowHeight,
  width: getWindowWidth
});
var getHeightWidthMax = exports.getHeightWidthMax = (0, _reselect.createStructuredSelector)({
  height: getWindowHeight,
  heightMax: getWindowHeightMax,
  width: getWindowWidth,
  widthMax: getWindowWidthMax
});